import Url from '@music/mobile-url';
import { makeActionCreator, makeActionType, getActionType } from '../util/redux';
import Request from '../util/fetch';
import { Toast } from '../component/message';
import History from '../util/history';
import {
    EditType, editSaveComplete, editSuccess, editFail
} from './edit';

export const PAGESIZE = 15;
export const WorkType = 'works';
const mockUserId = Url.CurrentParams.mockUserId || '';

makeActionType(WorkType, ['request0', 'request1', 'request2', 'request3', 'delrequest', 'delcomplete', 'savepage', 'tryrequest', 'trycomplete', 'clearsgtab', 'edititem', 'querylistrequest', 'queryliststatus', 'craftsuccess', 'craftfail']);
export const worksClear = makeActionCreator(getActionType(WorkType, 'clear'));
export const worksSuccess = makeActionCreator(getActionType(WorkType, 'success'));
export const worksFail = makeActionCreator(getActionType(WorkType, 'fail'));
export const worksComplete = makeActionCreator(getActionType(WorkType, 'delcomplete'));
export const worksSavePage = makeActionCreator(getActionType(WorkType, 'savepage'));
export const worksTryComplete = makeActionCreator(getActionType(WorkType, 'trycomplete'));
export const worksClearTab = makeActionCreator(getActionType(WorkType, 'clearsgtab'));
export const worksEidtItem = makeActionCreator(getActionType(WorkType, 'edititem'));
export const worksQueryList = makeActionCreator(getActionType(WorkType, 'queryliststatus'));
export const craftSuccess = makeActionCreator(getActionType(WorkType, 'craftsuccess'));
export const craftFail = makeActionCreator(getActionType(WorkType, 'craftfail'));
// 1-已发布，0-发布中，-1-已锁定
export const workRequest = data => (dispatch) => {
    // 0, 1, 2
    const cmode = 1 - parseInt(data.status, 10);
    const page = data.page;
    dispatch({
        type: getActionType(WorkType, `request${cmode}`),
        payload: data
    });
    // console.log('==request==', data.status);
    return (data.status === 0 ? Request.fetch({
        url: 'api/cloudvideo/video/publishing/list',
        data: {
            source: 1,
            limit: PAGESIZE,
            offset: (page - 1) * PAGESIZE,
        }
    })
        : Request.fetch({
            url: 'api/cloudvideo/video/list',
            data: {
                status: data.status,
                source: 1,
                limit: PAGESIZE,
                offset: Math.max((page - 1), 0) * PAGESIZE,
                mockUserId
            }
        }))
        .then((result) => {
            const resData = result.data;
            resData._status = cmode;
            resData._page = page;
            dispatch(worksSuccess(resData));
        })
        .catch((error) => {
            const rerr = Request.resolveError(error);
            rerr._status = cmode;
            dispatch(worksFail(rerr));
        });
};
// 获取我的草稿箱
export const craftRequest = data => (dispatch) => {
    const page = data.page;
    dispatch({
        type: getActionType(WorkType, `request${3}`),
        payload: data
    });
    return Request.fetch({
        url: 'api/cloudvideo/video/draft/list',
        data: {
            limit: PAGESIZE,
            offset: (page - 1) * PAGESIZE,
        }
    })
        .then((result) => {
            const resData = result.data;
            resData._page = page;
            dispatch(craftSuccess(resData));
        })
        .catch((error) => {
            const rerr = Request.resolveError(error);
            rerr._status = 3;
            dispatch(craftFail(rerr));
        });
};
// 表单操作 失败操作集
const OPRATE_FAIL = (dispatch, error) => {
    const rerr = Request.resolveError(error);
    Toast({
        type: 'error',
        text: rerr.msg
    });
    dispatch(editSaveComplete({}));
};
// 草稿 表单操作 成功操作集
const OPRATE_SUCESS = (dispatch, url) => {
    dispatch(editSaveComplete({ success: true }));
    History.push(url);
    dispatch(worksClearTab(3));
};
// 草稿 表单操作 init
const OPRATE_INIT = (dispatch) => {
    dispatch({
        type: getActionType(EditType, 'svrequest')
    });
};
// 草稿发布
export const craftReleaseRequest = data => (dispatch) => {
    OPRATE_INIT(dispatch);
    const t = +new Date();
    if (data && data.videoInfo) {
        data.videoInfo = JSON.stringify(data.videoInfo);
    }
    return Request.fetch({
        url: '/api/cloudvideo/video/draft/pub',
        data
    }).then((result) => {
        if (result.code === 206) {
            return result;
        }
        if (result.code === 207) {
            // OPRATE_FAIL(dispatch, error);
            Toast({
                type: 'error',
                text: result.message
            });
            return dispatch(editSaveComplete({}));
        }
        dispatch(workRequest({
            status: 0,
            page: 1
        }))
            .then(() => {
                OPRATE_SUCESS(dispatch, '/mywork?tab=1');
            })
            .catch((error) => {
                OPRATE_FAIL(dispatch, error);
            });
    }).catch((error) => {
        OPRATE_FAIL(dispatch, error);
    });
};
// 添加草稿
export const craftSaveRequest = data => (dispatch) => {
    OPRATE_INIT(dispatch);
    const t = +new Date();
    if (data && data.videoInfo) {
        data.videoInfo = JSON.stringify(data.videoInfo);
    }
    return Request.fetch({
        url: 'api/cloudvideo/video/draft/add',
        data
    })
        .then((result) => {
            if (result.code === 206) {
                return result;
            }
            OPRATE_SUCESS(dispatch, '/mywork?tab=3');
        })
        .catch((error) => {
            OPRATE_FAIL(dispatch, error);
        });
};
// 获取单个草稿详情
export const craftDetailRequest = data => (dispatch) => {
    dispatch({
        type: getActionType(EditType, 'request'),
        payload: data
    });
    return Request.fetch({
        url: 'api/cloudvideo/video/draft/get',
        data: {
            videoId: data.videoId,
        }
    })
        .then((data) => {
            dispatch(editSuccess(data));
        })
        .catch((error) => {
            const rerr = Request.resolveError(error);
            Toast({
                type: 'error',
                text: rerr.msg
            });
            dispatch(editFail(rerr));
        });
};
// 更新草稿
export const craftUpdateRequest = data => (dispatch) => {
    OPRATE_INIT(dispatch);
    data.videoInfo = JSON.stringify(data.videoInfo);
    return Request.fetch({
        url: 'api/cloudvideo/video/draft/update',
        data
    })
        .then((data) => {
            OPRATE_SUCESS(dispatch, '/mywork?tab=3');
        })
        .catch((error) => {
            OPRATE_FAIL(dispatch, error);
        });
};
// 删除草稿
export const delCraftRequest = data => (dispatch) => {
    OPRATE_INIT(dispatch);
    return Request.fetch({
        url: 'api/cloudvideo/video/draft/delete',
        data: {
            videoId: data
        }
    })
        .then((data) => {
            OPRATE_SUCESS(dispatch, '/mywork?tab=3');
        })
        .catch((error) => {
            OPRATE_FAIL(dispatch, error);
        });
};
// 替换草稿
export const overwriteCraftRequest = data => dispatch => Request.fetch({
    url: 'api/cloudvideo/video/draft/replace',
    data
}).then((data) => {
    OPRATE_SUCESS(dispatch, '/mywork?tab=3');
})
    .catch((error) => {
        OPRATE_FAIL(dispatch, error);
    });

// 删除
export const workDelRequest = data => (dispatch) => {
    // 0, 1, 2
    const cmode = parseInt(data.status, 10);
    const page = data.page;
    const videoId = data.videoId;
    const resourceType = data.resourceType;
    dispatch({
        type: getActionType(WorkType, 'delrequest'),
        payload: {
            videoId
        }
    });

    return Request.fetch({
        url: 'api/cloudvideo/video/delete',
        data: {
            videoId,
            mockUserId,
            resourceType
        }
    })
        .then((d) => {
            Toast({
                type: 'success',
                text: '删除成功'
            });
            if (page) {
                dispatch(worksComplete({
                    success: true,
                    page,
                    status: cmode,
                    videoId
                }));
            }
        })
        .catch((error) => {
            const rerr = Request.resolveError(error);
            Toast({
                type: 'error',
                text: rerr.msg
            });
            dispatch(worksComplete(rerr));
        });
};
// 重新发布
export const workTryRequest = data => (dispatch) => {
    // 0, 1, 2
    const cmode = parseInt(data.status, 10);
    const page = data.page;
    const videoId = data.videoId;
    dispatch({
        type: getActionType(WorkType, 'tryrequest'),
        payload: {
            videoId
        }
    });
    return Request.fetch({
        url: 'api/cloudvideo/video/republish',
        data: {
            videoId,
            mockUserId
        }
    })
        .then((data) => {
            dispatch(worksTryComplete({
                success: true,
                page,
                status: cmode,
                videoId
            }));
        })
        .catch((error) => {
            const rerr = Request.resolveError(error);
            Toast({
                type: 'error',
                text: rerr.msg
            });
            dispatch(worksTryComplete(rerr));
        });
};
// 查询抓取和转码状态
export const workQueryRequest = data => (dispatch) => {
    data = data || [];
    const page = data.page;
    delete data.page;
    dispatch({
        type: getActionType(WorkType, 'querylistrequest')
    });
    if (data.videoIds) {
        data.videoIds = JSON.stringify(data.videoIds);
    }
    data.mockUserId = mockUserId;
    return Request.fetch({
        url: 'api/cloudvideo/video/status/get/v2',
        data
    })
        .then((result) => {
            // console.log('==query==', data);
            const arr = result.data,
                qrsData = {};
            // 查询是否有完成发布
            let isFinish = false;
            for (const { videoId, publishStatus } of arr.values()) {
                if (publishStatus == 1) {
                    isFinish = true;
                }
                qrsData[videoId] = publishStatus;
            }
            if (isFinish) {
                dispatch(worksQueryList({
                    success: true,
                    data: qrsData,
                    page
                }));
                // 清空第一个tab且请求
                dispatch(workRequest({
                    status: 1,
                    page: 1,
                    _clear: true // 请求的时候清空之前的数据
                }));
            } else {
                dispatch(worksQueryList({}));
            }
        })
        .catch((error) => {
            const rerr = Request.resolveError(error);
            dispatch(worksQueryList(rerr));
        });
};



// WEBPACK FOOTER //
// ./client/action/works.js